import { NodeViewProps, NodeViewWrapper } from '@tiptap/react'; // Типы для NodeView
import React from 'react';

import { Chip } from '@/ui/Chip';
import { TagAttributes } from '@/ui/Editor/extensions/Tag/types';

const TagComponent = (props: NodeViewProps) => {
	const { node, deleteNode } = props;
	const { tag } = node.attrs as TagAttributes;

	return (
		<NodeViewWrapper className="inline-block">
			<Chip onRemove={deleteNode}>{tag}</Chip>
		</NodeViewWrapper>
	);
};

export default TagComponent;
